export default __webpack_public_path__ + "img/3.6d36a434.jpg";